<script>

  import { onDestroy, getContext } from 'svelte';
  import { key, setInfowindowContent } from './map.js';

  const { getMap, getInfowindow, getOverlay } = getContext(key);
  const map = getMap();
  const infowindow = getInfowindow();
  const overlay = getOverlay();

  export let project = {};
  export let typologyTable = {};

  let typology = project.typologies && project.typologies.length ? project.typologies[0] : {};
  let color = 'id' in typology ? typologyTable[typology.id].color : '';
  let position = new google.maps.LatLng(project.lat, project.lng);

  const svgMarker = {
    path: "M11.5,22.5c6.1,0,11-4.9,11-11s-4.9-11-11-11s-11,4.9-11,11S5.4,22.5,11.5,22.5",
    fillColor: '#0077FF',
    fillOpacity: 1,
    strokeColor: '#fff',
    strokeWeight: 1,
    rotation: 0,
    scale: 1,
    anchor: new google.maps.Point(11, 11),
  };

  if (color) {
    svgMarker.fillColor = color;
  }

  const infoContent = setInfowindowContent(typologyTable, project);

  const marker = new google.maps.Marker({
    position,
    map,
    icon: svgMarker,
    title: project.title,
  });

  marker.addListener("click", () => {
    infowindow.setContent(infoContent);
    infowindow.open({
      anchor: marker,
      map,
      shouldFocus: false,
    });
    overlay.setMap(map);
  });

  onDestroy(() => {
    if (marker) {
      google.maps.event.clearListeners(marker, 'click');
      marker.setMap(null);
      overlay.setMap(null);
    }
  });

</script>


